// components/SplashScreen.js
import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import cjsoilogo from '../assets/cjsoilogomain.png'

const SplashScreen = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'black',
      }}
    >
        <img src={cjsoilogo} alt='CJSOI Logo'/>
      <Typography variant="h3" fontWeight="bold" sx={{ mb: 2 }}>
        CJSOI 2025
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 4 }}>
        Chargement des informations sur les jeux...
      </Typography>
      <CircularProgress sx={{ color: 'black' }} />
    </Box>
  );
};

export default SplashScreen;
